import React  from 'react';
import { Switch } from 'react-router-dom';
import loadable from '@loadable/component';

// Styles.
import 'styles';

// Containers.
const AuthRequireContainer = loadable(() => import('containers/AuthRequireContainer'));
const LMSQuestMaterialPage = loadable(() => import('containers/LMSQuestMaterialPage'));

const NotFoundPage = loadable(() => import('containers/NotFoundPage'));
const ErrorPage = loadable(() => import('containers/ErrorPage'));

const AppContainer = ({ history }) => (
  <div className="appWrapper">
    <Switch>
      <AuthRequireContainer path="/lms/quest/materials/:materialId" component={LMSQuestMaterialPage} exact />
      <AuthRequireContainer path="/lms/quest/courses/:courseId/:materialId" component={LMSQuestMaterialPage} exact />

      <AuthRequireContainer path="/error" component={ErrorPage} theme="ink" />

      <AuthRequireContainer path="/page-404" component={NotFoundPage} status={404} theme="ink" />

      <AuthRequireContainer component={NotFoundPage} status={404} theme="ink" />
    </Switch>
  </div>
);

export default AppContainer;
